import paramsList from './params-list';
import { Params } from './types';
import { doBasicCheck, ValidationResult } from '../../validator/shared';
import optedOutAccountIds from '../../motors-finance-blacklist';

export default (params: Params): ValidationResult => {
    if (!doBasicCheck(params, paramsList).isValid) {
        return doBasicCheck(params, paramsList);
    }

    if (
        params.sellerType !== 'Private' &&
        params.accountId &&
        optedOutAccountIds.includes(parseInt(params.accountId))
    ) {
        return { isValid: false, reason: 'Trade seller has opted out of motors finance' };
    }

    return {
        isValid: true,
    };
};
